import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize, YodaFontWeight } from 'yoda-ui/yodaTheme';

export const GridListPaginationStyle: SxProps<Theme> = {
  width: '68px',
};

export const GridListSelectStyle: SxProps<Theme> = {
  height: '48px',
  fontSize: YodaFontSize.small,
  color: YodaColors.textSecondary,
  borderRadius: '8px',
  backgroundColor: YodaColors.white,

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: YodaColors.textSecondary,
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: YodaColors.textSecondary,
  },
};

export const GridListPaginationResultStyle: SxProps<Theme> = {
  color: YodaColors.textSecondary,
};

export const GridListPaginationCountStyle: SxProps<Theme> = {

  '& .MuiPagination-ul li:not(:first-of-type):not(:last-of-type) button': {
    color: YodaColors.textSecondary,

    '&:hover': {
      backgroundColor: 'transparent',
      color: YodaColors.blue8,
    },

    '&.Mui-selected': {
      color: YodaColors.blue7,
      fontWeight: YodaFontWeight.bold,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: 'none',
      outline: 'none',
    },

    '&.Mui-selected:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
};
